import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthContext } from '../App';
import { usePlatform } from '../contexts/PlatformContext';
import MaintenanceMode from './MaintenanceMode';

// Existing route guards still protect admin, wallet and billing access.
const RECOVERY_ROUTES = new Set(['/', '/admin', '/reset-password', '/risk-disclosure',
  '/polygon-wallet', '/trade', '/join', '/payment/success', '/payment/cancel', '/pending']);

export const PlatformMaintenanceBoundary = ({ children }) => {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();
  const { platformStatus, refreshStatus } = usePlatform();
  if (platformStatus.is_maintenance && user?.is_admin !== true && !RECOVERY_ROUTES.has(pathname)) {
    return <MaintenanceMode message={platformStatus.maintenance_message} onRefresh={refreshStatus} />;
  }
  return children;
};